/**
 * Predefined ticker symbols with their full company/fund names
 * Shared across SymbolBank and TickerDropdown components
 */
export const PREDEFINED_SYMBOLS: Record<string, string> = {
  SPY: "SPDR S&P 500 ETF Trust",
  AAPL: "Apple Inc.",
  TSLA: "Tesla, Inc.",
  MSFT: "Microsoft Corporation",
  NVDA: "NVIDIA Corporation",
  GOOGL: "Alphabet Inc.",
  AMZN: "Amazon.com, Inc.",
  META: "Meta Platforms, Inc.",
  SMH: "VanEck Semiconductor ETF",
  "BTC/USD": "Bitcoin / US Dollar",
  "ETH/USD": "Ethereum / US Dollar",
};
